import React from 'react'
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from '../components/Common/PageBanner'
import Footer from "../components/App/Footer"
import ServiceDetailsContentb from '../components/ServiceDetailsb/ServiceDetailsContentb'
import RelatedServicesb from '../components/ServiceDetailsb/RelatedServicesb'

const Details = () => {
    return (
        <Layout>
            <Navbar />
            <PageBanner
                pageTitle="Data Migration"
                homePageText="Home"
                homePageUrl="/"
                activePageText="Service Details"
            />
            <ServiceDetailsContentb />
            <RelatedServicesb />
            <Footer />
        </Layout>
    );
}

export default Details